// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_pg-0";
export var animationContainer = "_pg-1";
export var itemPrice = "_pg-a";
export var itemizedContent = "_pg-9";
export var itemizedHeader = "_pg-7";
export var itemizedRow = "_pg-8";
export var itemizedSection = "_pg-6";
export var modalContent = "_pg-2";
export var orderName = "_pg-3";
export var refundOption = "_pg-4";
export var refundOptionsContainer = "_pg-5";
export var shippingLabel = "_pg-b";
export var totalRow = "_pg-c";